const DeleteSubscriberContent = () => {
  return null;
};

export default DeleteSubscriberContent;
